export const SEARCH_BRANDED_FIXTURES = 'SEARCH_BRANDED_FIXTURES';
export const SEARCH_BRANDED_FIXTURES_SUCCESS = 'SEARCH_BRANDED_FIXTURES_SUCCESS';
export const SEARCH_BRANDED_FIXTURES_FAILED = 'SEARCH_BRANDED_FIXTURES_FAILED';

export const SET_SEARCH_BRANDED_FIXTURES = 'SET_SEARCH_BRANDED_FIXTURES';
export const SET_BRANDED_FIXTURES_SORT_CRITERIAS = 'SET_BRANDED_FIXTURES_SORT_CRITERIAS';

export const FETCH_BRANDED_FIXTURES = 'FETCH_BRANDED_FIXTURES';
export const FETCH_BRANDED_FIXTURES_SUCCESS = 'FETCH_BRANDED_FIXTURES_SUCCESS';
export const FETCH_BRANDED_FIXTURES_FAILED = 'FETCH_BRANDED_FIXTURES_FAILED';

export const CREATE_BRANDED_FIXTURE = 'CREATE_BRANDED_FIXTURE';
export const CREATE_BRANDED_FIXTURE_SUCCESS = 'CREATE_BRANDED_FIXTURE_SUCCESS';
export const CREATE_BRANDED_FIXTURE_FAILED = 'CREATE_BRANDED_FIXTURE_FAILED';

export const UPDATE_BRANDED_FIXTURE = 'UPDATE_BRANDED_FIXTURE';
export const UPDATE_BRANDED_FIXTURE_SUCCESS = 'UPDATE_BRANDED_FIXTURE_SUCCESS';
export const UPDATE_BRANDED_FIXTURE_FAILED = 'UPDATE_BRANDED_FIXTURE_FAILED';

export const FETCH_COLLECTIONS = 'FETCH_COLLECTIONS';
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_FAILED = 'FETCH_COLLECTIONS_FAILED';

export const FETCH_VENDOR_COLLECTION_LISTINGS = 'FETCH_VENDOR_COLLECTION_LISTINGS';
export const FETCH_VENDOR_COLLECTION_LISTINGS_SUCCESS = 'FETCH_VENDOR_COLLECTION_LISTINGS_SUCCESS';
export const FETCH_VENDOR_COLLECTION_LISTINGS_FAILED = 'FETCH_VENDOR_COLLECTION_LISTINGS_FAILED';

export const FETCH_OFFICE_FIXTURES = 'FETCH_OFFICE_FIXTURES';
export const FETCH_OFFICE_FIXTURES_SUCCESS = 'FETCH_OFFICE_FIXTURES_SUCCESS';
export const FETCH_OFFICE_FIXTURES_FAILED = 'FETCH_OFFICE_FIXTURES_FAILED';
export const FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES = 'FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES';
export const FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_SUCCESS = 'FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_SUCCESS';
export const FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_FAILED = 'FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_FAILED';
export const CLEAR_DEFAULT_OFFICE_BRANDED_FIXTURES = 'CLEAR_DEFAULT_OFFICE_BRANDED_FIXTURES';
export const SAVE_OFFICE_FIXTURES = 'SAVE_OFFICE_FIXTURES';
export const SAVE_OFFICE_FIXTURES_SUCCESS = 'SAVE_OFFICE_FIXTURES_SUCCESS';
export const SAVE_OFFICE_FIXTURES_FAILED = 'SAVE_OFFICE_FIXTURES_FAILED';

export const fetchBrandedFixtures = (payload?: any) => ({
  type: FETCH_BRANDED_FIXTURES,
  ...(payload && { payload }),
});

export const fetchBrandedFixturesSuccess = (payload: any) => ({
  type: FETCH_BRANDED_FIXTURES_SUCCESS,
  payload,
});

export const fetchBrandedFixturesFailed = (payload: any) => ({
  type: FETCH_BRANDED_FIXTURES_FAILED,
  payload,
});

export const createBrandedFixture = (payload: any) => ({
  type: CREATE_BRANDED_FIXTURE,
  payload,
});

export const createBrandedFixtureSuccess = (payload: any) => ({
  type: CREATE_BRANDED_FIXTURE_SUCCESS,
  payload,
});

export const createBrandedFixtureFailed = (payload: any) => ({
  type: CREATE_BRANDED_FIXTURE_FAILED,
  payload,
});

export const updateBrandedFixture = (payload: any) => ({
  type: UPDATE_BRANDED_FIXTURE,
  payload,
});

export const updateBrandedFixtureSuccess = (payload: any) => ({
  type: UPDATE_BRANDED_FIXTURE_SUCCESS,
  payload,
});

export const updateBrandedFixtureFailed = (payload: any) => ({
  type: UPDATE_BRANDED_FIXTURE_FAILED,
  payload,
});

export const setSearchBrandedFixture = (payload: any) => ({
  type: SET_SEARCH_BRANDED_FIXTURES,
  payload,
});

export const searchBrandedFixture = (payload: any) => ({
  type: SEARCH_BRANDED_FIXTURES,
  payload,
});

export const setBrandedFixturesSortCriterias = (payload: any) => ({
  type: SET_BRANDED_FIXTURES_SORT_CRITERIAS,
  payload,
});

export const searchBrandedFixtureSuccess = (payload: any) => ({
  type: SEARCH_BRANDED_FIXTURES_SUCCESS,
  payload,
});

export const searchBrandedFixtureFailed = (payload: any) => ({
  type: SEARCH_BRANDED_FIXTURES_FAILED,
  payload,
});

export const fetchCollections = (payload?: any) => ({
  type: FETCH_COLLECTIONS,
  ...(payload && { payload }),
});

export const fetchCollectionsSuccess = (payload: any) => ({
  type: FETCH_COLLECTIONS_SUCCESS,
  payload,
});

export const fetchCollectionsFailed = (payload: any) => ({
  type: FETCH_COLLECTIONS_FAILED,
  payload,
});

export const fetchVendorCollectionListings = () => ({
  type: FETCH_VENDOR_COLLECTION_LISTINGS,
});

export const fetchVendorCollectionListingsSuccess = (payload: any) => ({
  type: FETCH_VENDOR_COLLECTION_LISTINGS_SUCCESS,
  payload,
});

export const fetchVendorCollectionListingsFailed = (payload: any) => ({
  type: FETCH_VENDOR_COLLECTION_LISTINGS_FAILED,
  payload,
});

export const fetchOfficeFixtures = (locationSid: number) => ({
  type: FETCH_OFFICE_FIXTURES,
  payload: locationSid,
});

export const fetchOfficeFixturesSuccess = (payload: any) => ({
  type: FETCH_OFFICE_FIXTURES_SUCCESS,
  payload,
});

export const fetchOfficeFixturesFailed = (payload: any) => ({
  type: FETCH_OFFICE_FIXTURES_FAILED,
  payload,
});

export const fetchDefaultOfficeBrandedFixtures = (officeNumber: string) => ({
  type: FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES,
  payload: officeNumber,
});

export const fetchDefaultOfficeBrandedFixturesSuccess = (payload: any) => ({
  type: FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_SUCCESS,
  payload,
});

export const fetchDefaultOfficeBrandedFixturesFailed = (payload: any) => ({
  type: FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_FAILED,
  payload,
});

export const clearDefaultOfficeBrandedFixtures = () => ({
  type: CLEAR_DEFAULT_OFFICE_BRANDED_FIXTURES,
});

export const saveOfficeFixtures = (payload: { locationSid: number; brandedFixtureSids: number[] }) => ({
  type: SAVE_OFFICE_FIXTURES,
  payload,
});

export const saveOfficeFixturesSuccess = (payload: any) => ({
  type: SAVE_OFFICE_FIXTURES_SUCCESS,
  payload,
});

export const saveOfficeFixturesFailed = (payload: any) => ({
  type: SAVE_OFFICE_FIXTURES_FAILED,
  payload,
});
